import { render, staticRenderFns } from "./RelationsSearch.vue?vue&type=template&id=0b89b0cc&scoped=true&"
import script from "./RelationsSearch.vue?vue&type=script&lang=js&"
export * from "./RelationsSearch.vue?vue&type=script&lang=js&"
import style0 from "./RelationsSearch.vue?vue&type=style&index=0&id=0b89b0cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89b0cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b89b0cc')) {
      api.createRecord('0b89b0cc', component.options)
    } else {
      api.reload('0b89b0cc', component.options)
    }
    module.hot.accept("./RelationsSearch.vue?vue&type=template&id=0b89b0cc&scoped=true&", function () {
      api.rerender('0b89b0cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/global/RelationsSearch/RelationsSearch.vue"
export default component.exports